import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { en } from '../languages';
import axios from 'axios';
import store from '../../store'
import { availableLanguages } from "../../configs/global"
Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: en.name, // set locale
    fallbackLocale: en.name,
    messages: en.messages
});

const loadedLanguages = [en.name] // our default language that is preloaded 

export function setI18nLanguage(lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

export async function loadLanguageAsync(lang) {
    if (i18n.locale !== lang) {
        if (!loadedLanguages.includes(lang)) {
            try {
                const msgs = await import(/* webpackChunkName: "lang-[request]" */ `../../lang/${lang}`);
                i18n.setLocaleMessage(lang, msgs.default);
                loadedLanguages.push(lang);
                return setI18nLanguage(lang);
            }
            catch (error) {
                setI18nLanguage(loadedLanguages[0]);
            }
        }
        return Promise.resolve(setI18nLanguage(lang))
    }
    return Promise.resolve(lang)
}


export async function resolveLanguage() {
    let cookieLanguage = store.getters.languageCookie
    if (cookieLanguage) {
        try {
            await store.dispatch('setLanguageSelected', cookieLanguage)
            return Promise.resolve()
        } catch (e) {
            console.log(e)
        }
    } else {
        let browserLanguage = navigator.languages[0];
        browserLanguage = browserLanguage.indexOf("-") !== -1 ?
            browserLanguage.split("-")[0] : browserLanguage
        if (availableLanguages.includes(browserLanguage)) {
            try {
                await store.dispatch('setLanguageSelected', browserLanguage)
                return Promise.resolve()
            } catch (e) {
                console.log(e)
            }
        } else {
            try {
                await store.dispatch('setLanguageSelected', availableLanguages[0])
                return Promise.resolve()
            } catch (e) {
                console.log(e)
            }
        }

    }
}

// export function resolveLanguage(to, next) {
//     if (store.getters.languageCookie) {
//         store.commit("setLanguageSelected", store.getters.languageCookie)
//         store.dispatch('setLanguageAsync', store.getters.languageCookie).then(() => {
//             next()
//         })
//     } else if (store.getters.languageSelected) {
//         store.dispatch('setLanguageAsync', store.getters.languageSelected).then(() => {
//             next()
//         })
//     } else {
//         let browserLanguage = navigator.languages[0];
//         if (browserLanguage.indexOf("-") !== -1) {
//             browserLanguage = browserLanguage.split("-")[0];
//         }
//         store.commit("setLanguageSelected", browserLanguage)
//         store.dispatch('setLanguageAsync', browserLanguage).then(() => {
//             next()
//         }).catch((e) => {
//             next()
//         })
//     }
// }





// WEBPACK FOOTER //
// ./src/lang/setup/i18n-setup.js